<template>
  <div class="card" @mouseover="isHovered = true" @mouseout="isHovered = false" @click="navigateToBlog">
        <img v-lazy="`${imageSrc}`"
          width="256"
          height="144" 
        alt="Card Image">
        <h2>{{ title }}</h2>
        <!-- <h3>{{ contenttype }}</h3> -->
        <p class="details">{{ details }}</p>
        <p>
            <span class="discounted-price">₹{{ price }}</span>
            <span class="discount"><del>₹{{ list_price }}</del>
            ({{(((list_price - price) / list_price) * 100).toFixed(0) }}% off)
            </span>
        </p>
        <button @click.stop="navigateToCart" class="submit-button">Add to cart</button>
        <div>
    </div>
  </div>
</template>

<script>
import { default as ustore } from '@/stores/authStore.js';
import { supabase } from '../supabase';
import { default as cartStore } from '@/stores/cartStore.js';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';


export default {
    props: {
        imageSrc: String,
        title: String,
        contenttype: String,
        details: String,
        price: Number,
        list_price:Number,
         id: {
      type: Number,
      required: true,
    }
    },
  methods: {
    navigateToBlog() {
      // this.$router.push(`/course/${this.id}`);
      if (this.contenttype==='course'){
        this.$router.push({name:'course',params:{id:this.id}});

      }
      else{
        this.$router.push({name:'quiz',params:{id:this.id}});        
      }


    },
    calculateDiscount(listPrice, price) {
      return Math.round(((listPrice - price) / listPrice) * 100);
    },
 
   async navigateToCart(){
     if (ustore.uData.role != 'authenticated'){
          this.$router.push(`/signup/`);
      }
    else{
     if (!cartStore.cartData.some(item => item.product_id === this.id)) {
      const { error } = await supabase
      .from('cart')
      .insert({ user_id: this.ustore.uData.id, product_id:this.id,created_at: new Date(),updated_at: new Date() })
      console.log(error);
      cartStore.refresh();
       toast("Item added to the cart !", {
        autoClose: 1000,
         "theme": "dark",
        "type": "success",
      })
      
      ;

    }
    else{
        toast("Item already exists in the cart !", {
        autoClose: 1000,
         "theme": "dark",
        "type": "error",
      })
    }
  }
}
  
  },
    data() {
        return {
            isHovered: false,
            ustore:ustore,
            cartStore:cartStore,

        }
    }

}
</script>

<style scoped>
.card {
display: flex; /* Add this line */
flex-direction: column; /* Add this line */
border: 1px solid gray;
text-align: center;
transition: transform 0.3s ease, box-shadow 0.3s ease;
background: var(--sec-col);  
color:whitesmoke;
border-radius: 5px;
justify-content: center;
align-items: center;
max-width:250px;
margin-bottom: 15px;
margin-top: 15px;
}





.card img {
    width: 100%;
    height: auto;
    border-radius: 8px;
    margin-bottom: 8px;
    aspect-ratio: 16/9;
}

.card:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(243, 172, 172, 0.1);
}

.submit-button:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(243, 172, 172, 0.1);
    background: #baba19;
}

.submit-button{
  width:92%;
  height:40 px;
  align-content: center;
  cursor: pointer;
  padding: 8px;
  font-weight: 600;
  background-color: #ffff99;
  border-radius: 4px;
  color: #001233;
  border: 1px solid #8f9ba3;
  font-size: 15px;
  margin-bottom: 20px;
  text-align: center;
  margin-top: auto;
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.discounted-price{
  font-weight: 500;
  font-size: 30px;
  margin-right:7px;
  color: white;
}

.discount{
  font-size: 14px ;
  color: wheat;
}

.details{
  margin-left: 10px;
  margin-right: 10px;


}


@media (max-width: 768px) {
  .card{
    width:90vw;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}
</style>